// null is the "not created" state the UI renders.
export type CompanyMessageResponse = {
  hello_message: string | null;
  welcome_message: string | null;
};

export type UpdateCompanyMessage = {
  company_name: string;
  company: {
    hello_message?: string;
    welcome_message?: string;
  };
};

// Labels the API sends and accepts, not display text.
export const AFTER_HOURS_STRATEGIES = [
  'none',
  'voicemail',
  'voicemail_with_targets',
  'request_intake',
] as const;

export type AfterHoursStrategy = (typeof AFTER_HOURS_STRATEGIES)[number];

export type AfterHoursSettings = {
  time_zone: string;
  after_hours_strategy: AfterHoursStrategy;
  after_hours_voicemail_number: string;
};

export type UpdateAfterHoursSettings = {
  company_name: string;
  company: Partial<AfterHoursSettings>;
};

export type CompaniesResponse = {
  id: number;
  name: string;
  time_zone: string;
  call_handler: 'rai' | 'elevenlabs';
  active_conversational_agent_id: number | null;
  // Migration flag controlling whether generic rai call-center handoffs
  // route to the Command Center queue (true) vs. PSTN dial (false).
  // Defaults to false until early adopters validate the new path.
  command_center_handoff_enabled?: boolean;
  /** The company has an outgoing calls number, without which the CRM refuses every call. */
  outbound_calls_enabled: boolean;
}[];
